module.exports = __webpack_public_path__ + "svgs/SummerHouse.660823acab52bfa837f28128a8dc02b1.svg";